import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const Featured = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.xl};
  }
`
